import { render, staticRenderFns } from "./region-selector.vue?vue&type=template&id=53cb6b8b&"
import script from "./region-selector.vue?vue&type=script&lang=js&"
export * from "./region-selector.vue?vue&type=script&lang=js&"
import style0 from "./region-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports